enum Options {
    SCE = 'Comité ejecutivo',
    DZE = 'Delegado zona',
    DS = 'Delegado sindical',
}
export default Options;